import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SegmentItem } from '../../atoms';

export interface TagCardImgItem {
  icon?: string;
  iconColor?: string;
  slotIcon?: 'left' | 'right';
  label?: string;
  shape?: 'round' | 'squared';
  color?: string;
  size?: 'small' | 'medium' | 'large';
  fill?: 'solid' | 'outline';
}

@Component({
  selector: 'getm-top-image-detail',
  templateUrl: './top-image-detail.component.html',
  styleUrls: ['./top-image-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopImageDetailComponent implements OnInit, OnChanges {

  @Input() imagen: string | null = null;
  @Input() soloApp: boolean = false;
  @Input() recommender: number = 0;
  @Input() recommenderFill: 'solid' | 'outline' = 'solid';
  @Input() badges: TagCardImgItem[] = [];
  @Input() showZoom: boolean = true;
  @Input() defaultImage: string = '';
  @Input() marcas?: Array<{ Marca: string; URL_Imagen: string; }> = [];
  @Input() isPromo: boolean = false;
  @Input() isBonificacion: boolean = false;


  @Output() zoomClick = new EventEmitter<void>();
  @Output() badgeClick = new EventEmitter<number>();

  public segment: SegmentItem = { id: 0, title: '', subtitle: '', active: true, icon: '', color: '' };
  public segmentsGetmEcommerce: SegmentItem[] = [];
  public zoomIcon: string = 'scan-outline';

  constructor(
    private translateS: TranslateService,
  ) {
    this.segmentsGetmEcommerce = this.translateS.instant('Segments.GetmEcommerce')?.filter((segment: SegmentItem) => segment.active) || [];
  }

  ngOnInit() {
    this.updateRecommenderSegment();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['recommender']) {
      this.updateRecommenderSegment();
    }
  }

  private updateRecommenderSegment(): void {
    const rcmdr = this.segmentsGetmEcommerce.filter(segment => segment.id === this.recommender);
    this.segment = rcmdr.length > 0 ? rcmdr[0] : { id: 0, title: '', subtitle: '', active: true, icon: '', color: '' };
  }

  public canShowZoom(): boolean {
    if (!this.showZoom) {
      return false;
    }
    const currentImg = this.imagen?.trim();
    if (!currentImg) {
      return false;
    }
    const defaultImg = this.defaultImage?.trim();
    if (defaultImg && currentImg === defaultImg) {
      return false;
    }
    return true;
  }

  public onZoomClick = (): void => {
    if (this.canShowZoom()) {
      this.zoomClick.emit();
    }
  }

  public onBadgeClick = (index: number): void => {
    this.badgeClick.emit(index);
  }

  public trackByMarca = (_: number, marca: { Marca: string }): string => marca.Marca;
}
